import React, { useState, useEffect } from 'react'
import {Link, useHistory,useParams} from 'react-router-dom'
import Moment from 'moment'
import firebase from 'firebase'
import { Button, FormControl, Input} from '@material-ui/core'
import './Chat.css'
import { NavBar } from '../navBar'
import {TwitterTimelineEmbed} from 'react-twitter-embed'



export const ChatRoom = () => {
    const [chats, setChats] = useState([])
    const [users, setUsers] = useState([])
    const [nickname, setNickname] = useState('')
    const [roomname, setRoomname] = useState('')
    const [newchat, setNewchat] = useState({ roomname: '', nickname: '', message: '', date: '', type: '' })
    const history = useHistory()
    const { room } = useParams()

    useEffect(() => {
        const fetchData = async () => {
            setNickname(localStorage.getItem('nickname'))
            setRoomname(room)
            firebase.database().ref('chats/').orderByChild('roomname').equalTo(roomname).on('value', resp => {
              setChats([])
              setChats(snapshotToArray(resp))
            })
        }
      
        fetchData()
    }, [room, roomname])

    useEffect(() => {
        const fetchData = async () => {
            setNickname(localStorage.getItem('nickname'))
            setRoomname(room)
            firebase.database().ref('roomusers/').orderByChild('roomname').equalTo(roomname).on('value', (resp2) => {
              setUsers([])
              const roomusers = snapshotToArray(resp2)
              setUsers(roomusers.filter(x => x.status === 'online'))
            })
        }
      
        fetchData()
    }, [room, roomname])

    const snapshotToArray = (snapshot) => {
        const returnArr = []

        snapshot.forEach((childSnapshot) => {
            const item = childSnapshot.val()
            item.key = childSnapshot.key
            returnArr.push(item)
        })

        return returnArr
    }

    const submitMessage = (evt) => {
        evt.preventDefault()
        const chat = newchat
        chat.roomname = roomname
        chat.nickname = nickname
        chat.date = Moment(new Date()).format('DD/MM/YYYY HH:mm:ss')
        chat.type = 'message'
        const newMessage = firebase.database().ref('chats/').push()
        newMessage.set(chat)
        setNewchat({ roomname: '', nickname: '', message: '', date: '', type: '' })
    }

    const handleonChange = (evt) => {
        evt.persist()
        setNewchat({...newchat, [evt.target.name]: evt.target.value})
    }

    return (
        <>
            <NavBar />
        <div className='chat__rooms__container'>
         {chats.map((item, index) => (
         <div key={index} className='chat__message__container'>
             {item.type ==='join'?
                 <div className='joined__users'>
                     <span className='user__date'>{item.date}</span>
                     <span className='message__content'>{item.message}</span>
                 </div>:
                 <div className='chat__message'>
                     <div className={`${item.nickname === nickname? 'current__user':'other__users'}`}>
                     {item.nickname === nickname ? 
                         <span className='user__nickname'>Me</span>:<span className='user__nickname'>{item.nickname}</span>
                     }
                     <span className='message__send__date'> at {item.date}</span>
                     <p>{item.message}</p>
                     </div>
                 </div>
             }
         </div>
     ))}
             <div id = 'message__action__container'>
         <Input type='text' name='message' id='message' placeholder='Enter message here' value={newchat.message} onChange={handleonChange} />
                 <Button variant='primary' type='submit' onClick = {submitMessage}>Send</Button>
                 <br />
                 <button id = 'back__to__rooms__button'>
                        <Link to = '/roomlist'>Go Back</Link>
                </button>
        </div>
        </div>

        <div className ='twitter'>
         <TwitterTimelineEmbed
          id='twitter'
          sourceType="profile"
          screenName="NIMHgov"
          options={{ height: 600, width: 500 }}
        />
    </div>
        </>
        
    )
}
